import React from "react";
import {
  Zap,
  Monitor,
  Lock,
  BarChart3,
  Database,
  Network,
  Server,
  GitBranch,
  Cloud,
  Cpu,
  Globe,
  Users,
  Settings,
  Archive,
  Shield,
  Code2,
} from "lucide-react";
import { logger } from "@/lib/logger";
import type { AgentCompetency } from "@/lib/agent-competencies";

interface CompetencyCardProps {
  competency: AgentCompetency;
  className?: string;
}

// Icon mapping for dynamic icon rendering
const iconMap = {
  Zap,
  Monitor,
  Lock,
  BarChart3,
  Database,
  Network,
  Server,
  GitBranch,
  Cloud,
  Cpu,
  Globe,
  Users,
  Settings,
  Archive,
  Shield,
  Code2,
};

const CompetencyCard: React.FC<CompetencyCardProps> = ({
  competency,
  className = "",
}) => {
  const IconComponent = iconMap[competency.icon as keyof typeof iconMap];

  if (!IconComponent) {
    logger.warn(`Icon ${competency.icon} not found in iconMap`);
    return null;
  }

  return (
    <div
      className={`bg-white dark:bg-slate-800 rounded-xl p-6 border border-slate-200 dark:border-slate-700 ${className}`}
    >
      <div className="flex items-center mb-3">
        <IconComponent className={`h-6 w-6 text-${competency.color} mr-3`} />
        <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100">
          {competency.name}
        </h3>
      </div>
      <p className="text-slate-600 dark:text-slate-400 text-sm">
        {competency.description}
      </p>
    </div>
  );
};

export default CompetencyCard;
